import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AppError } from 'src/app/core/errors/http-error/app-error';
import { WindowService } from 'src/app/shared/components/window/window.service';
import {Simulation, SimulationAreaResultClass} from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';

@Component({
  selector: 'app-simulation-validation',
  templateUrl: './simulation-validation.component.html',
  styleUrls: ['./simulation-validation.component.scss']
})
export class SimulationValidationComponent implements OnInit {

  isLoading: boolean;
  error: AppError;
  result: { classes: SimulationAreaResultClass[], total: SimulationAreaResultClass };

  constructor(
    private simulationQuery: SimulationQuery,
    private simulationService: SimulationService,
    private windowService: WindowService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    const simulation = this.simulationQuery.getActive();
    this.validate(simulation);
  }

  execute() {
    this.isLoading = true;
    const id = this.simulationQuery.getActiveId();

    this.simulationService.execute(id)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(error => {
          this.error = error;
          return throwError(error);
        })
      )
      .subscribe(s => {
        this.simulationService.add(s);
        const snacktitle = $localize`Validation in progress`;
        const close = $localize`CLOSE`;
        this.snackBar.open(snacktitle, close, { duration: 3000 });
        this.windowService.close(this);
        this.simulationService.desactive();
      });
  }

  private validate(simulation: Simulation) {
    this.simulationService.validateSimulation(simulation)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(error => {
          this.error = error;
          // console.log(this.error);
          return throwError(error);
        })
      )
      .subscribe((validate: any) => {
        this.result = validate;
        this.result.total = {
          collective_nres_abs: this.result.classes.map(c => c.collective_nres_abs).reduce((a,b) => a + b),
          collective_nres_rel: this.result.classes.map(c => c.collective_nres_rel).reduce((a,b) => a + b),
          collective_res_abs: this.result.classes.map(c => c.collective_res_abs).reduce((a,b) => a + b),
          collective_res_rel: this.result.classes.map(c => c.collective_res_rel).reduce((a,b) => a + b),
          economic_class: '',
          individual_nres_abs: this.result.classes.map(c => c.individual_nres_abs).reduce((a,b) => a + b),
          individual_nres_rel: this.result.classes.map(c => c.individual_nres_rel).reduce((a,b) => a + b),
          individual_res_abs: this.result.classes.map(c => c.individual_res_abs).reduce((a,b) => a + b),
          individual_res_rel: this.result.classes.map(c => c.individual_res_rel).reduce((a,b) => a + b)
        };
        // console.log(this.result);
      });
  }

  closed() {
    this.windowService.closeByClass(SimulationValidationComponent);
  }
}
